var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 355.163 355.163",
    style: {
      enableBackground: "new 0 0 355.163 355.163"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_521_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_522_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_874_",
    style: {
      fill: "#682234"
    },
    d: "M288.22,141.269C288.22,59.796,245.474,0,177.579,0S66.939,59.796,66.939,141.269 c0,21.095-14.08,42.87,8.3,65.903c-3.374,4.791-5.361,10.629-5.361,16.934c0,16.268,13.188,29.456,29.456,29.456 c3.489,0,6.833-0.61,9.939-1.723c19.56,27.308,43.932,37.6,68.307,37.6s48.747-10.292,68.307-37.601 c3.105,1.113,6.451,1.724,9.939,1.724c16.268,0,29.456-13.188,29.456-29.456c0-6.305-1.988-12.143-5.361-16.934 C302.299,184.139,288.22,162.364,288.22,141.269z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_875_",
    style: {
      fill: "#581A2B"
    },
    d: "M288.22,141.269C288.22,59.796,245.474,0,177.579,0l0,0v289.44 c24.375,0,48.747-10.292,68.307-37.601c3.105,1.113,6.451,1.724,9.939,1.724c16.268,0,29.456-13.188,29.456-29.456 c0-6.305-1.988-12.143-5.361-16.934C302.299,184.139,288.22,162.364,288.22,141.269z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_876_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_877_",
    style: {
      fill: "#F3D8B6"
    },
    d: "M294.561,314.025v40.681H60.598v-40.681c0-30.431,14.377-56.963,37.605-70.913 c6.043-3.641,12.69-6.43,19.844-8.196c5.953-1.488,12.254-2.272,18.842-2.272l40.691,24.002l40.691-24.002 c6.588,0,12.889,0.784,18.842,2.272c7.154,1.766,13.802,4.554,19.844,8.196C280.185,257.062,294.561,283.594,294.561,314.025z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_878_",
    style: {
      fill: "#EEC8A2"
    },
    d: "M256.957,243.111c-6.042-3.641-12.69-6.429-19.844-8.196 c-5.953-1.488-12.254-2.272-18.842-2.272l-40.691,24.002l0,0v98.06h116.982v-40.681 C294.561,283.594,280.185,257.062,256.957,243.111z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_879_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_880_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_881_",
    style: {
      fill: "#F3D8B6"
    },
    d: "M205.909,176.777h-26.884h-1.256h-0.379h-1.256H149.25 c0,74.552-36.43,67.808-36.43,67.808c0,47.368,51.162,62.392,63.313,66.806v1.537c0,0,0.533-0.11,1.446-0.359 c0.912,0.249,1.446,0.359,1.446,0.359v-1.537c12.151-4.414,63.313-19.439,63.313-66.806 C242.339,244.585,205.909,251.329,205.909,176.777z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_882_",
    style: {
      fill: "#EEC8A2"
    },
    d: "M205.909,176.777h-26.884h-1.256h-0.189V312.57 c0.912,0.249,1.446,0.359,1.446,0.359v-1.537c12.151-4.414,63.313-19.439,63.313-66.806 C242.339,244.586,205.909,251.329,205.909,176.777z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_883_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_884_",
    style: {
      fill: "#F3DBC4"
    },
    d: "M114.72,81.496c-3.943,32.882,0.967,73.676,7.203,85.19 c9.042,16.694,29.221,38.957,55.657,38.957c26.431,0,46.607-22.262,55.652-38.957c3.833-7.078,7.166-25.22,8.25-45.786 C234.579,120.448,136.198,113.47,114.72,81.496z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_885_",
    style: {
      fill: "#EDCEAE"
    },
    d: "M177.579,111.728v93.914c0,0,0.001,0,0.002,0 c26.431,0,46.607-22.262,55.652-38.957c3.833-7.078,7.166-25.22,8.25-45.786C237.754,120.656,207.859,118.54,177.579,111.728z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_886_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_889_",
    style: {
      fill: "#367992"
    },
    d: "M294.038,319.996h0.533v-5.97c0-10.18-1.617-19.92-4.629-28.902h0.288 c-5.751-17.762-16.955-32.605-32.027-42.08c-0.408-0.257-0.808-0.526-1.222-0.774c-1.922-1.16-12.316,18.895-21.601,29.047 h-57.788l0,0h-0.166h-57.641c-12.703-14.652-18.974-30.621-21.583-29.047c-15.695,9.429-27.343,24.61-33.249,42.854h0.268 c-3.011,8.982-4.629,18.722-4.629,28.902v5.97h0.551l-0.533,0.5v34.667h116.806h80.176h36.98v-34.667L294.038,319.996z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_892_",
    style: {
      fill: "#2F697E"
    },
    d: "M294.57,314.026c0-10.18-1.617-19.92-4.629-28.902h0.288 c-5.751-17.762-16.955-32.605-32.027-42.08c-0.408-0.257-0.808-0.526-1.222-0.774c-1.922-1.16-12.316,18.895-21.601,29.047 h-57.788l0,0h-0.01v83.846h80.01h36.98v-34.667l-0.533-0.5h0.533v-5.97H294.57z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_893_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    style: {
      fill: "#FFEB99"
    },
    d: "M241.889,263.081c0,0-38.387,81.333-64.309,81.333s-64.309-81.333-64.309-81.333 H241.889z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_894_",
    style: {
      fill: "#FFE477"
    },
    d: "M177.579,263.081v81.333c25.921,0,64.309-81.333,64.309-81.333H177.579z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.205a608592fcc89b540fb282bf5c8425.svg";
export { ForwardRef as ReactComponent };